import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function DashboardLoading() {
  return <RouteLoadingShell variant="dashboard" />;
}
